import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import "./App.scss";
import LandingPage from "../../views/pages/landingPage";
import Success from "../../views/pages/Success";
import ProductPage from "../../views/pages/productPage";
import CalculatePremium from "../../views/pages/calculatePremium";
import BuyFlowNew from "../../views/pages/buyFlowNew";

function App() {
  return (
    <div className="App">
      <Switch>
        <Route path="/product/:plan" exact component={ProductPage} />
        <Route
          path="/product/:plan/calculate"
          exact
          component={CalculatePremium}
        />
        <Route path="/product/:plan/register" exact component={BuyFlowNew} />
        <Route path="/product/:plan/success" exact component={Success} />
        <Route path="/:id/:token" exact component={LandingPage} />
        <Route path="/" component={LandingPage} />
        <Route exact path="**">
          <Redirect to="/" />
        </Route>
      </Switch>
    </div>
  );
}

export default App;
